export const headers = [
  { field: "id", headerName: "ID", hidden: true },
  { field: "depo_descripcion", headerName: "Nombre", minWidth: 240 },
  { field: "sucursal", headerName: "Sucursal", minWidth: 240 },
  { field: "direccion", headerName: "Dirección", minWidth: 240 },
];
